"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _texts = require("../texts");
var _lists = require("../lists");
var Button = _interopRequireWildcard(require("../buttons"));
var _util = require("../../util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var BLOCK_CLASS = 'pf-provider-search-result';
var Result = function Result(_ref) {
  var total = _ref.total,
    results = _ref.results,
    onSelect = _ref.onSelect;
  var bem = (0, _util.klass)(BLOCK_CLASS);
  if (results === null) return null;
  if (!results.length) return /*#__PURE__*/_react.default.createElement("div", {
    className: bem('no-results-found')
  }, /*#__PURE__*/_react.default.createElement(_texts.Base, null, "Sorry! We are unable to process your request at this time. Please try again later."));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: BLOCK_CLASS
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: bem('header')
  }, /*#__PURE__*/_react.default.createElement(_texts.TableHeader, {
    className: bem('header-line')
  }, "We found ", total, " practices matching your search."), /*#__PURE__*/_react.default.createElement(_texts.TableHeader, {
    className: bem('header-line')
  }, "Can't find your provider? Try entering more information to narrow down your search.")), /*#__PURE__*/_react.default.createElement(_lists.List, null, /*#__PURE__*/_react.default.createElement(_lists.ListItem, {
    id: "header"
  }, /*#__PURE__*/_react.default.createElement(_texts.Base, null, "Practice"), /*#__PURE__*/_react.default.createElement(_texts.Base, null, "Location"), /*#__PURE__*/_react.default.createElement(_texts.Base, null, "City")), results.map(function (result) {
    return /*#__PURE__*/_react.default.createElement(_lists.ListItem, {
      id: result.client_id
    }, /*#__PURE__*/_react.default.createElement(_texts.Base, null, result.client_name), /*#__PURE__*/_react.default.createElement(_texts.Base, null, result.address), /*#__PURE__*/_react.default.createElement(_texts.Base, {
      as: "div"
    }, /*#__PURE__*/_react.default.createElement(_texts.Base, null, result.city, ","), /*#__PURE__*/_react.default.createElement(_texts.Base, {
      as: "span"
    }, result.state, " "), /*#__PURE__*/_react.default.createElement(_texts.Base, {
      as: "span"
    }, result.zip)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Button.Secondary, {
      onClick: function onClick(e) {
        return onSelect(e, result);
      }
    }, "Select")));
  })));
};
Result.propTypes = {
  total: _propTypes.default.number.isRequired,
  results: _propTypes.default.arrayOf(_propTypes.default.shape({
    client_id: _propTypes.default.string,
    client_name: _propTypes.default.string,
    address: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    zip: _propTypes.default.string
  })),
  onSelect: _propTypes.default.func.isRequired
};
Result.defaultProps = {
  results: null
};
var _default = exports.default = Result;
